import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@airclou/ui';
import { AlertTriangle } from 'lucide-react';

interface ErrorStateProps {
  title: string;
  description: string;
  onRetry?: () => void;
  /** Show the retry as in progress, so a slow retry isn't invisible. */
  isRetrying?: boolean;
}

export function ErrorState({ title, description, onRetry, isRetrying = false }: ErrorStateProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 mb-4">
        <AlertTriangle className="w-6 h-6 text-red-600 dark:text-red-400" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">{title}</h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6 text-center max-w-md">{description}</p>
      {onRetry && (
        <LoadingButton onClick={onRetry} variant="outline" loading={isRetrying}>
          {t('errorState.tryAgain')}
        </LoadingButton>
      )}
    </div>
  );
}
